import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Pie } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend, Title, Decimation } from 'chart.js';
import ChartDataLabels from "chartjs-plugin-datalabels";
import './BbsVoteVisualization.css';
import './swalStyle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons';
Chart.register(Tooltip, Legend, ArcElement, Title, Decimation, ChartDataLabels);

function BbsVoteVisualization({ data, bbsDate, title }) {
  const navigate = useNavigate();
  const voteId = data[0].voteId;
  const chartLabels = data.map((item) => item.content);
  const chartData = data.map((item) => item.cnt);
  const colorPalette = ['#f1a8bc', '#eee58a', '#c4ecb0', '#addbd8', '#d6b0eb',
                        '#a9e5cc', '#dcedc1', '#fed2b5', '#ffaba7', '#ff8b94',
                        '#ffb3b7', '#fedcdd', '#dbe5f1', '#a5bcde', '#7d9dcd',
                        '#cde4d2', '#d2e1a8', '#d8de7e', '#deda52', '#aad67',];

  const getRandomColors = (count) => {
    const selectedColors = colorPalette.slice(0, count);
    return [...selectedColors, ...Array(colorPalette.length - count).fill(null).map(() => colorPalette[Math.floor(Math.random() * colorPalette.length)])];
  };

  const chartDataConf = {
    labels: chartLabels,
    datasets: [
      {
        data: chartData,
        backgroundColor: getRandomColors(chartData.length),
        hoverBackgroundColor: getRandomColors(chartData.length),
      },
    ],
  };

  const movingToVoteDetail = () => {
    navigate('/', { state: { setFromMokLok : '투표상세', setNoticeDetailId: voteId, setBbsDate: bbsDate } });
  }

  const options = {
    plugins: {
        title : {
            display: true,
            text: title,
            font: {
                size: 16,
                weight: 'bold',
            }
        },
        legend: {
            display: true,
            position: 'right',
        },
        datalabels: {
            color: '#fff',
            anchor: 'center',
            align: 'center',
            offset: 8,
            font: {
                weight: 'bold',
            },
            formatter: (value, context) => {
              const label = context.chart.data.labels[context.dataIndex];
              return value !== 0 ? `${value}명` : '';
            },
        },
        tooltip: {
            enabled: false,
        }
    },
  };

  return (
    <div style={{ padding: '5px' }}>
      <div className="visualization-button-container">
        <button onClick={movingToVoteDetail}><FontAwesomeIcon icon={faCaretLeft} />뒤로가기</button>
      </div>
      <div className="chart-container">
        <Pie data={chartDataConf} options={options}/>
      </div>
    </div>
  );
}

export default BbsVoteVisualization;
